import { render, staticRenderFns } from "./BsaTotalData.vue?vue&type=template&id=edcf673e"
import script from "./BsaTotalData.vue?vue&type=script&lang=js"
export * from "./BsaTotalData.vue?vue&type=script&lang=js"
import style0 from "./BsaTotalData.vue?vue&type=style&index=0&id=edcf673e&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edcf673e')) {
      api.createRecord('edcf673e', component.options)
    } else {
      api.reload('edcf673e', component.options)
    }
    module.hot.accept("./BsaTotalData.vue?vue&type=template&id=edcf673e", function () {
      api.rerender('edcf673e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/bsa/BsaTotalData.vue"
export default component.exports